const UsersListItemId = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListItemId')
const UsersListItemProfilePicture = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListItemProfilePicture')
const UsersListItemName = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListItemName')
const UsersListItemEmail = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListItemEmail')
const UsersListItemPhone = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListItemPhone')
const UsersListItemCompany = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListItemCompany')
const ListItemActiveDot = () => import('@/components/Engine/ListItemActiveDot')
const UsersListActions = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListActions')

const usersModel = vm => ({
  title: vm.$gettext('Users'),
  endpoint: 'users',
  countrize: 'country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true,
      component: (value, key, item) => ({
        is: UsersListItemId,
        props: { value, item }
      })
    },
    {
      key: 'profile_picture',
      sortable: false,
      label: vm.$gettext('Picture'),
      component: (value, key, item) => ({
        is: UsersListItemProfilePicture,
        props: { item }
      })
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      component: (value, key, item) => ({
        is: UsersListItemName,
        props: { item }
      })
    },
    {
      key: 'email',
      label: vm.$gettext('Email'),
      sortable: true,
      editable: true,
      component: (value, key, item) => ({
        is: UsersListItemEmail,
        props: { item }
      })
    },
    {
      key: 'phone',
      label: vm.$gettext('Phone'),
      component: (value, key, item) => ({
        is: UsersListItemPhone,
        props: { item }
      })
    },
    {
      key: 'company_id',
      sortable: true,
      label: vm.$gettext('Company'),
      formatter: (value, key, item) => {
        return item.company ? item.company.name : ''
      },
      component: (value, key, item) => ({
        is: UsersListItemCompany,
        props: { item }
      })
    },
    {
      key: 'active',
      type: Boolean,
      editable: false,
      label: vm.$gettext('Enabled'),
      component: value => ({
        is: ListItemActiveDot,
        props: { value }
      })
    },
    {
      key: 'created_at',
      label: vm.$gettext('Created At'),
      sortable: true
    },
    {
      key: 'updated_at',
      label: vm.$gettext('Updated At'),
      sortable: true
    },
    {
      key: 'actions',
      label: vm.$gettext('Actions'),
      hidden: true,
      component: (value, key, item, row) => ({
        is: UsersListActions,
        props: { row },
        on: {
          refresh: () => vm.$root.$emit('bv::refresh::table', 'apiListTable')
        }
      })
    }
  ],
  filters: ['id', 'name', 'email', 'phone', 'company_id', 'tags.name'],
  includes: ['tags', 'company.tags']
})

export default usersModel
